/**
 * walkDemoActive — true while the admin Show me page (job #653) is playing a
 * walk inside View as.
 *
 * View as normally hides every write control (SchoolsContainer's isAdminView),
 * and a walk that points at the Invite button would then point at nothing.
 * While this is on, the persona's real controls render so the walk can show
 * them, and the fetch guard refuses EVERY write — Supabase table writes and
 * our own /api writes alike — so the page stays exactly as read-only as View
 * as has always been. It only ever turns on under View as, which only an SSi
 * admin can start, and it turns off when the walk ends.
 *
 * Pack-free, so the container and the fetch guard read it without loading
 * the walkthrough pack.
 */
import { ref } from 'vue'

export const walkDemoActive = ref(false)
